import axios from 'axios'
import store from '@state/store'

export const logIn = ({ email, password }) => {
  return axios.post('/auth/login', {
    email,
    password,
  })
}

export const logInWithOkta = ({ email, sessionToken }) => {
  return axios.post('/auth/login', {
    email,
    sessionToken,
  })
}

export const oktaSessionCookieRedirect = ({ sessionToken, redirectUrl }) => {
  const oktaUrl = `${process.env.OKTA_URL}login/sessionCookieRedirect?token=${sessionToken}&redirectUrl=${redirectUrl}`

  window.open(oktaUrl, '_self')
}

export const requestPasswordReset = ({ primaryEmail }) => {
  return axios.post('/auth/reset-password-email', {
    primary_email: primaryEmail,
  })
}

export const loadResetPasswordForm = ({ token }) => {
  return axios.get('/auth/reset-password-form?token=' + token)
}

export const submitResetPasswordForm = ({ oktaId, password, recoveryAnswer }) => {
  return axios.post('/auth/reset-password', {
    oktaId,
    password,
    recoveryAnswer,
  })
}

export const loadResetSecurityQuestionForm = ({ token }) => {
  return axios.get('/auth/reset-security-question-form?token=' + token)
}

export const submitResetSecurityQuestionForm = ({ oktaId, recoveryQuestion, recoveryAnswer }) => {
  return axios.post('/auth/reset-security-question', {
    oktaId,
    recoveryQuestion,
    recoveryAnswer,
  })
}

export const submitExpiredPasswordForm = ({ oldPassword, newPassword, sessionToken }) => {
  return axios.post('/auth/expired-password', {
    oldPassword,
    newPassword,
    sessionToken,
  })
}

export const loadRegisterForm = ({ oktaId }) => {
  return axios.get('/auth/recovery-questions/' + oktaId)
}

export const submitRegisterForm = ({
  oktaId,
  password,
  recoveryQuestion,
  recoveryAnswer,
  optInToMarketingTexts = false,
  phoneMobile = null,
}) => {
  return axios.post('/auth/register', {
    oktaId,
    password,
    recoveryQuestion,
    recoveryAnswer,
    optInToMarketingTexts,
    phoneMobile,
  })
}

export const loadResetAccountAccessForm = ({ oktaId }) => {
  return axios.get('/auth/reset-account-access/' + oktaId)
}

export const submitResetAccountAccessForm = ({ oktaId, password, recoveryQuestion, recoveryAnswer }) => {
  return axios.post('/auth/reset-account-access', {
    oktaId,
    password,
    recoveryQuestion,
    recoveryAnswer,
  })
}

export const getMyUser = () => {
  return axios.get('/personnel-management/user')
}

export const getMyUserDebug = (debugUserID) => {
  return axios.get('/personnel-management/debug/user', { params: { debugUserId: debugUserID } })
}

export const putMyUser = ({ userDetails }) => {
  return axios.put(`/personnel-management/user/${store.getters['user/currentUser'].id}`, { ...userDetails })
}

export const emailChangeConfirmation = ({ id, hash }) => {
  return axios.post('/user/email-change-confirmation', {
    id,
    hash,
  })
}
